// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementContentBlocksTerritoriesResult = objectOf({
  used_territories: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});
